import {clearString, getAlphabet} from "../helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = true, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)//
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let characters = cleared.split('');
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                cyphered.push(-1);
            } else {
                cyphered.push(getAlphabet(hasCh).indexOf(char));
            }
        }
        return cyphered//.join(sep).replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        return null
    },
};

export default {...methods,SEPARATOR}